import script from "./sendOtpPopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./sendOtpPopup.vue?vue&type=script&setup=true&lang=ts"

import "./sendOtpPopup.vue?vue&type=style&index=0&id=4c3327f4&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c3327f4"]])

export default __exports__